import React from 'react';
import CommentsDashboard from 'containers/pages/comments/CommentsDashboard';

export default function Comments() {
	return <CommentsDashboard />;
}
